// Module
var code = `<li ng-class="{ 'tab-title--active': active, 'disabled': disabled, 'tab-title': !active }"><a class="a-without-href" ng-click="select()" tab-heading-transclude>{{heading}}</a></li>`;
// Exports
export default code;